import React from "react";
import appstyles from "../styles/app.module.css";
function VideoPlayer({ setIsModal, videotoPLay,videoid } ){


    function handleModal(){
        setIsModal(false);
    }
    React.useEffect(() =>{
        const videoElement = refPlayer.current;


        const handleVideoEnded = () => {
            setIsModal(false);
        };


        videoElement.addEventListener("ended", handleVideoEnded);


        return () => {
            videoElement.removeEventListener("ended", handleVideoEnded);
        };
    }, [setIsModal]);
const refPlayer = React.useRef();
    const posterpath = "files/public/pagevideos/videos/";

    return(
    <section className={appstyles.modawlrapper}>
   <section className={appstyles.videplayercontainer}>

    <span className={appstyles.closebutton} onClick={ handleModal }>X</span>

       <video
       ref={refPlayer}
       controls
       autoPlay={true}
       src={`${posterpath}${videotoPLay.videoid}.mp4`}
   />





   </section>

    </section>
    )
}
export default VideoPlayer;